/** @format */

import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { RatingService } from '@product-reviews/utils';
import { ReviewSummary } from '@shared/data-access/interfaces';

@Component({
	selector: 'product-reviews-bv-reviews',
	templateUrl: './review-bv-reviews.component.html',
	styleUrl: 'review-bv-reviews.component.scss',
	standalone: false
})
export class ReviewBVReviewsComponent implements AfterViewInit {
	/**
	 *
	 * @description
	 * Product Id - Bizaar voice uses this identifier to display the correct reviews
	 */
	@Input() public productIdentifier: string;

	/**
	 *
	 * @description
	 * Review summary data from bizaar voice reviews.json API
	 * Used to create review summary bar
	 */
	@Input() public reviewSummary: ReviewSummary;

	/**
	 *
	 * @description
	 * isPanelOpen Flag used to check if sidePanel is open, defaulted to false
	 */
	public isPanelOpen = false;

	/**
	 * @description
	 * Display rating Summary
	 */
	public displayRatingSummaryAndHideBody = false;

	/**
	 * @description
	 * Accordian open/close
	 */
	public isCollapsed = false;

	constructor(
		@Inject(DOCUMENT) private document: any,
		@Inject(PLATFORM_ID) protected platformId: any,
		private ratingService: RatingService
	) {}

	ngAfterViewInit() {
		this.ratingService.addMutationObserver(
			'#bv-review-summary',
			this.addClickListenerToBVButtonContainer.bind(this)
		);
		this.isCollapsed = false;
		this.displayRatingSummaryAndHideBody = false;

		// Call to get the breakpoint only once, and only force recalculate on resize!
		// const deviceBreakPoint = this.deviceService.getDeviceBreakPoint();

		// Commented out for now in order to show reviews on page load
		// const isMobile = (deviceBreakPoint === BreakPoint.SMALL || deviceBreakPoint === BreakPoint.EXTRASMALL);
		// if (isMobile) {
		// 	this.isCollapsed = true;
		// 	this.displayRatingSummaryAndHideBody = true;
		// }
		// else {
		// 	this.isCollapsed = false;
		// 	this.displayRatingSummaryAndHideBody = false;
		// }
	}

	/**
	 * @description
	 * Set click listener to bv button container in order to stop propagation on button click
	 * @param {NodeListOf<ChildNode>} childNodes - Child nodes of parent div #bv-review-summary
	 */

	public addClickListenerToBVButtonContainer(childNodes: NodeListOf<ChildNode>) {
		if (childNodes.length > 0) {
			const bvdiv = this.document.getElementsByClassName('bv_button_component_container');
			if (bvdiv !== undefined && bvdiv !== null && bvdiv.length > 0) {
				bvdiv.item(0).addEventListener('click', this.bvButtonListener);
			}
		}
	}

	/**
	 * @description
	 * Button listener to prevents event propagation
	 * @param event - Child nodes of parent div #bv-review-summary
	 */
	public bvButtonListener(event: Event) {
		event.stopPropagation();
	}

	/**
	 * @description
	 * Set displayRatingSummaryAndHideBody
	 * @param accordionCollapsed - value that displayRatingSummaryAndHideBody will be set to
	 */
	public setDisplayRatingSummaryAndHideBody(accordionCollapsed: boolean) {
		this.displayRatingSummaryAndHideBody = accordionCollapsed;
	}
}
